import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

/**
 * Horizontal divider shown between passenger rows on small screens.
 */
export default function PassengerRowMobileDivider() {
  return (
    <Grid sx={{ display: { sm: "flex", md: "none" }, width: "100%" }} mt={1.5} mb={1}>
      <Box sx={{ display: "flex", height: "1px", backgroundColor: "#d3d3d3", width: "100%" }} />
    </Grid>
  );
}
